import { useNavigate } from '@tanstack/react-router';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { AdminLevelTypeFilter } from '@/components/admin-levels/table/filters/AdminLevelTypeFilter';
import { BackendTable } from '@/components/table/BackendTable';
import { I18N_DE } from '@/i18n/de';
import { AdminLevel } from '@/modules/api';
import { i18nSortingFn } from '@/utils/i18nSortingFn';

const columnHelper = createColumnHelper<AdminLevel>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Name',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('type', {
    header: 'Ebene',
    enableGlobalFilter: false,
    filterFn: 'arrIncludesSome',
    sortingFn: i18nSortingFn(I18N_DE.AdminLevelType),
    cell: (info) => I18N_DE.AdminLevelType[info.getValue()],
  }),
  columnHelper.accessor(
    (row) => (row.parent ? `${row.parent.name} (${I18N_DE.AdminLevelType[row.parent?.type]})` : ''),
    {
      id: 'adminLevelParent',
      enableColumnFilter: false,
      header: 'Übergeordnete Verwaltungsebene',
    },
  ),
] as ColumnDef<AdminLevel>[];

type AdminLevelsTableProps = { data?: AdminLevel[]; isFetching: boolean; fullHeight?: boolean };

export function AdminLevelsTable({ data, isFetching, fullHeight }: AdminLevelsTableProps) {
  const navigate = useNavigate();

  return (
    <BackendTable
      columns={columns}
      getRowId={(row) => row.id}
      data={data}
      isFetching={isFetching}
      fullHeight={fullHeight}
      searchInputPlaceholder="Suche nach Name"
      subject="Verwaltungsebenen"
      onClick={(row) =>
        navigate({ to: '/administration/verwaltungsebenen/$adminLevelId', params: { adminLevelId: row.original.id } })
      }
      filters={{ type: AdminLevelTypeFilter }}
    />
  );
}
